module.exports = __webpack_public_path__ + "static/nginr-ab2e287622b7212bc12fac47cf7f53c9.png";